import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import React, { useState } from "react";

export const SwitchBaja = (props) => {
  const [baja, setBaja] = useState(false);

  const handleChange = (event) => {
    setBaja(event.target.checked);
    props.setBaja(event.target.checked)
  };

  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Switch
            {...(props.disabledCheckBaja ? { disabled: true } : {})}
            checked={baja}
            onChange={handleChange}
            inputProps={{ "aria-label": "controlled" }}
          />
        }
        label="Baja"
      />
    </FormGroup>
  );
};
